import { render, staticRenderFns } from "./side-ads.vue?vue&type=template&id=238c072b"
import script from "./side-ads.vue?vue&type=script&lang=js"
export * from "./side-ads.vue?vue&type=script&lang=js"
import style0 from "./side-ads.vue?vue&type=style&index=0&id=238c072b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports